import * as React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import useHistory from "routing/useHistory";
import AIManagementRoutes from "ai-management/Routes";
import AIManagementPageNavigation from "ai-management/AIManagementPageNavigation";
import ModelProviderForm from "ai-management/model-providers/form/ModelProviderForm";
const CreateModelProviderPage = () => {
  const { t } = useTranslation("enterprise_ai");
  const history = useHistory();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("create_model_provider_page.document_title") }, /* @__PURE__ */ React.createElement(AIManagementPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: t("create_model_provider_page.title") }, /* @__PURE__ */ React.createElement("span", null, t("create_model_provider_page.description"))), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(
    ModelProviderForm,
    {
      onSaved: (id) => history.push(AIManagementRoutes.modelProviderEdit(id)),
      onCancel: () => history.push(AIManagementRoutes.MODEL_PROVIDERS)
    }
  ))));
};
export default CreateModelProviderPage;
